import { axios, base } from '../http';

export const getUserConsumerListPage = (params) => {
  return axios.get(`${base}/api/UserConsumer/get`, { params: params });
};

//水电控终端消费记录分�?

export const getPowerControlRecords = (params) => {
  return axios.get(`${base}/api/UserConsumer/GetPowerControlRecords`, {
    params: params,
  });
};

//导出消费记录

export const exportConsumptionRecords = (params) => {
  return axios.get(`${base}/api/UserConsumer/ExportConsumptionRecords`, {
    params: params,
    skipGlobalHttpErrorToast: true,
    responseType: "blob", // 指定响应类型�?blob
  });
};

//导出水电控消费记�?

export const exportPowerControlRecords = (params) => {
  return axios.get(`${base}/api/UserConsumer/ExportPowerControlRecords`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

//充值记�?

export const getRechargeListPage = (params) => {
  return axios.get(`${base}/api/UserConsumer/getrechargelist`, {
    params: params,
  });
};

//退款记�?

export const getRefundList = (params) => {
  return axios.get(`${base}/api/UserConsumer/GetRefundList`, {
    params: params,
  });
};

// 导出退款记�?

export const exportRefundList = (params) => {
  return axios.get(`${base}/api/UserConsumer/ExportRefundList`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

//手动充值分页记�?

export const getManualRechargeListPage = (params) => {
  return axios.get(`${base}/api/UserConsumer/GetManualRechargeListPage`, {
    params: params,
  });
};

// 导出充值记�?

export const exportRechargeList = (params) => {
  return axios.get(`${base}/api/UserConsumer/ExportRechargeList`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

// 导出手动充值记�?

export const exportManualRechargeList = (params) => {
  return axios.get(`${base}/api/UserConsumer/ExportManualRechargeList`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

//导出充值汇总表（每天总额，区分在线充�?手动充值，支持部门过滤�?

export const exportRechargeSummary = (params) => {
  return axios.get(`${base}/api/UserConsumer/ExportRechargeSummary`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

export const revocation = (params) => {
  return axios.post(`${base}/api/UserConsumer/Revocation`, params);
};

//手动充值
export const manualRechargeBalance = (params) => {
  return axios.post(`${base}/api/UserConsumer/ManualRecharge`, params);
};

/** 批量手动充值（仅 blogadmin / admin）。创建于 2026-08-21 */
export const batchManualRechargeBalance = (params) => {
  return axios.post(`${base}/api/UserConsumer/BatchManualRecharge`, params);
};

//查询手动充值记录
export const getManualRechargeList = (params) => {
  return axios.get(`${base}/api/UserConsumer/GetManualRechargeList`, {
    params: params,
  });
};

//账户余额报表

export const getUserBalanceList = (params) => {
  return axios.get(`${base}/api/UserConsumer/GetUserBalanceList`, {
    params: params,
  });
};

// 导出账户余额报表

export const exportUserBalanceList = (params) => {
  return axios.get(`${base}/api/UserConsumer/ExportUserBalanceList`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

export const getUserAccountChange = (params) => {
  return axios.get(`${base}/api/UserConsumer/GetUserAccountChange`, {
    params: params,
  });
};

export const getUserRefundRecords = (params) => {
  return axios.get(`${base}/api/UserConsumer/GetUserRefundRecords`, {
    params: params,
  });
};

// 挂失消费�?

export const lossCard = (params) => {
  return axios.post(`${base}/api/ConsumerCardStatus/LossCard`, params);
};

// 解除挂失消费�?

export const unlossCard = (params) => {
  return axios.post(`${base}/api/ConsumerCardStatus/UnlossCard`, params);
};

//同步用户到消费终�?

export const syucUser = (params) => {
  console.trace("SyucUser called! Params:", params);
  return axios.post(`${base}/api/ConsumerTerminal/SyucUser`, params);
};

//同步用户到天波平�?


//同步订餐到消费终�?


//获取同步用户到天波任务列�?


//获取同步用户到天波任务详�?


// 获取公共学期列表 (用于统计类页面全局过滤)

export const getDinnerTimeListPage = (params) => {
  return axios.get(`${base}/api/DinnerTime/get`, { params: params });
};

export const getDinnerTimeList = (params) => {
  return axios.get(`${base}/api/DinnerTime/GetList`, { params: params });
};

export const removeDinnerTime = (params) => {
  return axios.delete(`${base}/api/DinnerTime/delete`, { params: params });
};

export const editDinnerTime = (params) => {
  return axios.put(`${base}/api/DinnerTime/put`, params);
};

export const addDinnerTime = (params) => {
  return axios.post(`${base}/api/DinnerTime/post`, params);
};

// 优惠补贴

export const getDiscountSubsidyListPage = (params) => {
  return axios.get(`${base}/api/DiscountSubsidy/get`, { params: params });
};

export const getDiscountSubsidyList = (params) => {
  return axios.get(`${base}/api/DiscountSubsidy/GetList`, { params: params });
};

export const removeDiscountSubsidy = (params) => {
  return axios.delete(`${base}/api/DiscountSubsidy/delete`, { params: params });
};

export const editDiscountSubsidy = (params) => {
  return axios.put(`${base}/api/DiscountSubsidy/put`, params);
};

export const addDiscountSubsidy = (params) => {
  return axios.post(`${base}/api/DiscountSubsidy/post`, params);
};

// 优惠补贴用户

export const getDiscountSubsidyUserListPage = (params) => {
  return axios.get(`${base}/api/DiscountSubsidyUser/get`, { params: params });
};

export const removeDiscountSubsidyUser = (params) => {
  return axios.delete(`${base}/api/DiscountSubsidyUser/delete`, {
    params: params,
  });
};

export const editDiscountSubsidyUser = (params) => {
  return axios.put(`${base}/api/DiscountSubsidyUser/put`, params);
};

export const addDiscountSubsidyUser = (params) => {
  return axios.post(`${base}/api/DiscountSubsidyUser/post`, params);
};

// 导出优惠补贴用户

export const exportDiscountSubsidyUser = (params) => {
  return axios.get(
    `${base}/api/DiscountSubsidyUser/ExportDiscountSubsidyUser`,
    {
      params: params,
      responseType: "blob", // 指定响应类型�?blob
    },
  );
};

/** 上传教职工名册对比补贴用户（仅标记，不自动增删）。创建于 2026-09-16 */
export const compareDiscountSubsidyRoster = (formData) => {
  return axios.post(
    `${base}/api/DiscountSubsidyUser/CompareRosterExcel`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 120000,
    },
  );
};

export const refund = (params) => {
  return axios.post(`${base}/api/Alipay/Refund`, params);
};

/** 充值订单单笔原路退款。创建于 2026-09-01 */
export const refundRechargeOrder = (params) => {
  return axios.post(`${base}/api/Alipay/RefundRechargeOrder`, params);
};

// 体温区间配置

// 校车终端设备�?

export const getUserConsumptionSummary = (params) => {
  return axios.get(`${base}/api/UserConsumer/GetUserConsumptionSummary`, {
    params: params,
  });
};

//水电控终端消费汇�?

export const getPowerUserConsumptionSummary = (params) => {
  return axios.get(`${base}/api/UserConsumer/GetPowerUserConsumptionSummary`, {
    params: params,
  });
};

//消费汇总报�?

export const getTerminalConsumptionSummary = (params) => {
  return axios.get(`${base}/api/UserConsumer/GetTerminalConsumptionSummary`, {
    params: params,
  });
};

//水电控终端消费汇�?

export const getPowerTerminalConsumptionSummary = (params) => {
  return axios.get(
    `${base}/api/UserConsumer/GetPowerTerminalConsumptionSummary`,
    {
      params: params,
    },
  );
};

// 导出消费汇总报�?

export const exportUserConsumptionSummary = (params) => {
  return axios.get(`${base}/api/UserConsumer/ExportUserConsumptionSummary`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

// 导出水电控终端消费汇总报�?

export const exportPowerUserConsumptionSummary = (params) => {
  return axios.get(
    `${base}/api/UserConsumer/ExportPowerUserConsumptionSummary`,
    {
      params: params,
      responseType: "blob", // 指定响应类型�?blob
    },
  );
};

// 导出终端消费汇总报�?

export const exportTerminalConsumptionSummary = (params) => {
  return axios.get(
    `${base}/api/UserConsumer/ExportTerminalConsumptionSummary`,
    {
      params: params,
      responseType: "blob", // 指定响应类型�?blob
    },
  );
};

// 导出消费终端汇总报表（按安装位置分组合计）

export const exportTerminalConsumptionSummaryWithInstallAddressTotal = (
  params,
) => {
  return axios.get(
    `${base}/api/UserConsumer/ExportTerminalConsumptionSummaryWithInstallAddressTotal`,
    {
      params: params,
      responseType: "blob", // 指定响应类型�?blob
    },
  );
};

// 导出水电控终端消费汇总报�?

export const exportPowerTerminalConsumptionSummary = (params) => {
  return axios.get(
    `${base}/api/UserConsumer/ExportPowerTerminalConsumptionSummary`,
    {
      params: params,
      responseType: "blob", // 指定响应类型�?blob
    },
  );
};

// 消费限次模式用户

export const getConsumerLimitTimesUserListPage = (params) => {
  return axios.get(`${base}/api/ConsumerLimitTimesUser/get`, {
    params: params,
  });
};

export const removeConsumerLimitTimesUser = (params) => {
  return axios.delete(`${base}/api/ConsumerLimitTimesUser/delete`, {
    params: params,
  });
};

export const editConsumerLimitTimesUser = (params) => {
  return axios.put(`${base}/api/ConsumerLimitTimesUser/put`, params);
};

export const addConsumerLimitTimesUser = (params) => {
  return axios.post(`${base}/api/ConsumerLimitTimesUser/post`, params);
};

/**
 * 导出限次模式用户
 */
export const exportConsumerLimitTimesUser = (params) => {
  return axios.get(
    `${base}/api/ConsumerLimitTimesUser/ExportConsumerLimitTimesUser`,
    {
      params: params,
      responseType: "blob",
    },
  );
};

// 体温规则

export const getSubsidyStudentListPage = (params) => {
  return axios.get(`${base}/api/SubsidyStudent/get`, { params: params });
};
//新增补贴用户

export const addSubsidyStudent = (params) => {
  return axios.post(`${base}/api/SubsidyStudent/post`, params);
};
//删除补贴用户

export const deleteSubsidyStudent = (params) => {
  return axios.delete(`${base}/api/SubsidyStudent/Delete`, { params: params });
};

/** 专项账号：保存分组/充值开关/每日消费上限 */

export const putSubsidyStudentSettings = (params) => {
  return axios.put(`${base}/api/SubsidyStudent/PutSettings`, params);
};

/** 专项账号：启用/停用 */

export const putSubsidyStudentStatus = (params) => {
  return axios.put(`${base}/api/SubsidyStudent/PutStatus`, params);
};

/** 专项余额：手动充值、扣除、冲正 */

export const manualSubsidyBalance = (params) => {
  return axios.post(`${base}/api/SubsidyStudent/ManualSubsidyBalance`, params);
};

/** 专项余额变动明细 */

export const getSubsidyAccountChange = (params) => {
  return axios.get(`${base}/api/SubsidyStudent/GetSubsidyAccountChange`, { params });
};

/** 专项手动充值记录（冲正用） */

export const getSubsidyManualRechargeList = (params) => {
  return axios.get(`${base}/api/SubsidyStudent/GetSubsidyManualRechargeList`, { params });
};

/** 专项账号分组列表 */

export const getSubsidyStudentGroupList = (params) => {
  return axios.get(`${base}/api/SubsidyStudentGroup/GetList`, { params });
};

/** 专项账号管理员分页 */

export const getSubsidyAccountAdminListPage = (params) => {
  return axios.get(`${base}/api/SubsidyAccountAdmin/GetList`, { params });
};

export const addSubsidyAccountAdmin = (params, config) => {
  return axios.post(`${base}/api/SubsidyAccountAdmin/Add`, params, config);
};

export const editSubsidyAccountAdmin = (params) => {
  return axios.post(`${base}/api/SubsidyAccountAdmin/Edit`, params);
};

export const deleteSubsidyAccountAdmin = (params) => {
  return axios.post(`${base}/api/SubsidyAccountAdmin/Delete`, null, { params });
};

export const addSubsidyStudentGroup = (params, config) => {
  return axios.post(`${base}/api/SubsidyStudentGroup/Add`, params, config);
};

export const editSubsidyStudentGroup = (params) => {
  return axios.post(`${base}/api/SubsidyStudentGroup/Edit`, params);
};

export const deleteSubsidyStudentGroup = (params) => {
  return axios.post(`${base}/api/SubsidyStudentGroup/Delete`, null, { params });
};

//查询限免用户

export const getFreeUserManageListPage = (params) => {
  return axios.get(`${base}/api/FreeUserManage/get`, { params: params });
};
//新增限免用户

export const addFreeUserManage = (params) => {
  return axios.post(`${base}/api/FreeUserManage/post`, params);
};
//删除限免用户

export const deleteFreeUserManage = (params) => {
  return axios.delete(`${base}/api/FreeUserManage/Delete`, { params: params });
};

//查询固定金额用户

export const getFixedAmountUserManageListPage = (params) => {
  return axios.get(`${base}/api/FixedAmountUserManage/get`, { params: params });
};
//新增固定金额用户

export const addFixedAmountUserManage = (params) => {
  return axios.post(`${base}/api/FixedAmountUserManage/post`, params);
};
//删除固定金额用户

export const deleteFixedAmountUserManage = (params) => {
  return axios.delete(`${base}/api/FixedAmountUserManage/Delete`, {
    params: params,
  });
};

//查询班级扩展信息

export const exportStudentMealDetail = (params) => {
  return axios.get(`${base}/api/UserConsumer/ExportStudentMealDetail`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

// 获取值日检查类�?

export const consumerOpsPreviewParseLog = (data) => {
  return axios.post(`${base}/api/ConsumerOpsMaintenance/PreviewParseLog`, data);
};

export const consumerOpsExecuteFromLog = (data) => {
  return axios.post(`${base}/api/ConsumerOpsMaintenance/ExecuteFromLog`, data);
};

/** 运维台：余额退回前置判断（BalanceRefundOpsMaintenanceController）。创建于 2026-06-13 */

export const balanceRefundOpsGetPrecheckList = (params) => {
  return axios.get(`${base}/api/BalanceRefundOpsMaintenance/GetPrecheckList`, { params });
};

export const balanceRefundOpsExportPrecheckList = (params) => {
  return axios.get(`${base}/api/BalanceRefundOpsMaintenance/ExportPrecheckList`, {
    params,
    responseType: 'blob'
  });
};

export const balanceRefundOpsExecuteExtendableRefund = (data) => {
  return axios.post(`${base}/api/BalanceRefundOpsMaintenance/ExecuteExtendableRefund`, data);
};

export const balanceRefundOpsGetRefundBatchLogList = (params) => {
  return axios.get(`${base}/api/BalanceRefundOpsMaintenance/GetRefundBatchLogList`, { params });
};

export const balanceRefundOpsGetRefundBatchLogDetail = (params) => {
  return axios.get(`${base}/api/BalanceRefundOpsMaintenance/GetRefundBatchLogDetail`, { params });
};

/** 运维台：学生主卡号批量解绑（StudentCardOpsMaintenanceController）。创建于 2026-06-16 */

export const getConsumptionSchoolSettings = (params) => {
  return axios.get(`${base}/api/ConsumptionConfig/GetSchoolSettings`, { params });
};

export const saveConsumptionSchoolSettings = (data) => {
  return axios.post(`${base}/api/ConsumptionConfig/SaveSchoolSettings`, data);
};

export const getConsumptionSchoolDevices = (params) => {
  return axios.get(`${base}/api/ConsumptionConfig/GetSchoolDevices`, { params });
};

export const getConsumptionSchoolWhiteList = (params) => {
  return axios.get(`${base}/api/ConsumptionConfig/GetSchoolWhiteList`, { params });
};

export const saveConsumptionSchoolWhiteList = (data) => {
  return axios.post(`${base}/api/ConsumptionConfig/SaveSchoolWhiteList`, data);
};

export const deleteConsumptionSchoolWhiteList = (data) => {
  return axios.post(`${base}/api/ConsumptionConfig/DeleteSchoolWhiteList`, data);
};

export const searchConsumptionConfigUsers = (params) => {
  return axios.get(`${base}/api/ConsumptionConfig/SearchUsers`, { params });
};

export const getLossLogPageList = (params) => {
  return axios.get(`${base}/api/ConsumerCardStatus/GetLossLogPageList`, { params: params });
};

// 学期值日笑脸评选排行（后台）
